<template>
  <div>
    <div class="uppercase font-bold text-xs mb-1 tracking-widest">
      Voir nos prix dégressifs
    </div>
    <ul ref="menu" class="relative">
      <li class="sky__select-box justify-between" @click="toggleMenu">
        <div v-if="selected">
          x{{ selected.minimal_quantity }} :
          <template v-if="$store.getters['auth/paysTaxes']">
            {{ $helpers.formatCurrency(selected.unit_taxed_price * selected.minimal_quantity) }}
          </template>
          <template v-else>
            {{ $helpers.formatCurrency(selected.unit_price * selected.minimal_quantity) }}
            <small v-if="!$store.getters['auth/paysTaxes']">HT</small>
          </template>
        </div>
        <icon-select-down style="width: 10px;" />
      </li>
      <li v-show="menu" class="relative">
        <ul class="absolute left-0 right-0">
          <li
            v-for="dp in available"
            :key="dp.minimal_quantity"
            class="sky__select-box selectable z-50 relative"
            @click="() => {
              internalValue = allDecreasingPrices.indexOf(dp)
              closeMenu()
              $emit('input', dp.minimal_quantity)
            }"
          >
            x{{ dp.minimal_quantity }}:
            <template v-if="$store.getters['auth/paysTaxes']">
              {{ $helpers.formatCurrency(dp.unit_taxed_price * dp.minimal_quantity) }}
            </template>
            <template v-else>
              {{ $helpers.formatCurrency(dp.unit_price * dp.minimal_quantity) }}
              <small v-if="!$store.getters['auth/paysTaxes']" class="ml-1">HT</small>
            </template>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      default: null,
      type: Number
    },
    product: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      internalValue: 0,
      menu: false
    }
  },
  computed: {
    selected () {
      if (!this.allDecreasingPrices.length) {
        return null
      }

      return this.allDecreasingPrices[this.internalValue]
    },
    available () {
      return this.allDecreasingPrices.filter((dp) => {
        return dp !== this.internalValue
      })
    },
    allDecreasingPrices () {
      return [
        {
          unit_crossed_price: this.product.pricing.unit_crossed_price,
          unit_crossed_taxed_price: this.product.pricing.unit_crossed_taxed_price,
          unit_price: this.product.pricing.unit_price,
          unit_taxed_price: this.product.pricing.unit_taxed_price,
          minimal_quantity: 1 // TODO: Check if we have to replace by PCB for professionals here
        },
        ...this.product.pricing.decreasing_prices
      ]
    }
  },
  beforeDestroy () {
    this.closeMenu()
  },
  methods: {
    closeMenu () {
      this.menu = false
      document.removeEventListener('click', this.closeListener)
    },
    closeListener (e) {
      if (!this.$refs.menu.contains(e.target)) {
        this.closeMenu()
      }
    },
    openMenu () {
      this.menu = true
      document.addEventListener('click', this.closeListener)
    },
    toggleMenu () {
      if (this.menu) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    }
  }
}
</script>
